import clsx from 'clsx'
import React, { FC } from 'react'

import styles from './AiTag.module.scss'

/* eslint-disable max-len */
const AI_TEXT_PATH = 'M14.9847 23L18.1747 15.95H18.9147L22.1047 23H21.2547L20.4347 21.15H16.6247L15.7947 23H14.9847ZM16.9347 20.44H20.1247L18.5347 16.87L16.9347 20.44ZM23.5551 23V16H24.3451V23H23.5551Z'
const AI_SPARKLE_PATH = 'M26.5 9.93652C26.6422 10.4455 26.7672 10.8711 26.8984 11.2275C27.0994 11.7733 27.3178 12.183 27.6357 12.501C27.9548 12.8199 28.3546 13.0272 28.8809 13.2061C29.1784 13.3072 29.5244 13.4 29.9277 13.5C29.5244 13.6 29.1784 13.6928 28.8809 13.7939C28.3546 13.9728 27.9548 14.1801 27.6357 14.499C27.3178 14.817 27.0994 15.2267 26.8984 15.7725C26.7673 16.1286 26.6421 16.554 26.5 17.0625C26.3579 16.554 26.2327 16.1286 26.1016 15.7725C25.9006 15.2267 25.6822 14.817 25.3643 14.499C25.0452 14.1801 24.6454 13.9728 24.1191 13.7939C23.8214 13.6928 23.475 13.6001 23.0713 13.5C23.475 13.3999 23.8214 13.3072 24.1191 13.2061C24.6454 13.0272 25.0452 12.8199 25.3643 12.501C25.6822 12.183 25.9006 11.7733 26.1016 11.2275C26.2328 10.8711 26.3578 10.4455 26.5 9.93652Z'
/* eslint-enable max-len */

const AiTag: FC<{ className?: string }> = ({ className }) => (
  <div aria-hidden="true" className={clsx(styles.aiTag, className)}>
    <svg fill="none" height="40" viewBox="0 0 40 40" width="40" xmlns="http://www.w3.org/2000/svg">
      <path d={AI_TEXT_PATH} fill="#FAF6F0" />
      <path d={AI_SPARKLE_PATH} stroke="#FAF6F0" strokeWidth="0.5" />
    </svg>
  </div>
)

export default AiTag
